import { Button } from '../ui/button';

interface CropperActionsProps {
  allCropsComplete: boolean;
  completedCount: number;
  totalCount: number;
  onContinue: () => void;
}

export function CropperActions({
  allCropsComplete,
  completedCount,
  totalCount,
  onContinue,
}: CropperActionsProps) {
  return (
    <div className="flex justify-between items-center">
      <p className="text-sm text-muted-foreground">
        {completedCount} / {totalCount} ratios completed
      </p>
      <Button
        onClick={onContinue}
        disabled={!allCropsComplete}
        size="lg"
      >
        Continue to Production
      </Button>
    </div>
  );
}
